import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import dayjs from 'dayjs';
import { components } from 'src/types/schema';

// Use the type from schema.d.ts
type DeliveryData = components['schemas']['PartnersSubscriptionsDeliveriesSelectedFood'];

type Props = {
  row: DeliveryData;
};

export default function OrderTableRow({
  row
}: Props) {
  return (
    <TableRow hover>
      <TableCell align="left">{row.subscription.customer.user.phone_number}</TableCell>
      <TableCell align="left">{row.subscription.customer.area.name_en}</TableCell>
      <TableCell align="left">{row.subscription.customer.block}</TableCell>
      <TableCell align="left">{row.subscription.customer.street}</TableCell>
      <TableCell align="left">{row.subscription.customer.avenue || ''}</TableCell>
      <TableCell align="left">{row.subscription.customer.house}</TableCell>
      <TableCell align="left">{row.date}</TableCell>
      <TableCell align="left">{row.subscription.delivery_time ?
        `${dayjs(row.subscription.delivery_time.start_time, 'HH:mm:ss').format('hh:mm A')} - ${dayjs(row.subscription.delivery_time.end_time, 'HH:mm:ss').format('hh:mm A')}` : ''}</TableCell>
    </TableRow>
  );
}
